export default "__VITE_ASSET__M15CMEDT__"